
/**
 * Declare Variable
 */
const state = {
  // Whether the map is done loading
  loaded: false,

  // Charging locations
  locations: [],
  selectedChargingPointRefId: null,
  suggestedChargingpoint: null,
  isSuggestionModeActive: false,
}

const getters = {
  isLoaded: state => state.loaded,

  isChargingpointSelected: state => !!(state.selectedChargingPointRefId ?? state.suggestedChargingpoint?.coordinates),
  getSelectedChargingpoint: state => state.locations.find(pt => pt._id === state.selectedChargingPointRefId),
  getSuggestedChargingpoint: state => state.suggestedChargingpoint,
  getChargingPointByRefId: state => ({ _id }) => state.locations.find(pt => pt._id === _id),
  hasSuggestions: state => state.locations.find((location) => location.properties?.status === 'suggestion'),
  isSuggestionModeActive: state => state.isSuggestionModeActive,
  //
  getLocations: state => state.locations,
}
const actions = {
  async getChargingLocations({ dispatch, commit, rootState: { config } }, { previewCode, after }) {
    const { municipalityCode } = config.participationConfig

    const api = await fetch('/.netlify/functions/chargingpoints', {
      method: 'POST',
      body: JSON.stringify({ municipalityCode, previewCode, after }),
    })

    if (! api.ok) {
      throw new Error('Loading charging points failed!')
    }

    const response = await api.json()

    if (response?.chargingpoints) {
      commit('setChargingLocations', { locations: response.chargingpoints })
    }

    if (response.after) {
      return await dispatch('getChargingLocations', { previewCode, after: response.after })
    }
  },
  selectChargingPoint({ commit }, { _id }) {
    commit('setSelectedChargingPoint', { _id })
  },
  deselectChargingPoint({ commit }) {
    commit('setSelectedChargingPoint', { _id: null })
  },
  setSuggestedChargingPoint({ commit }, { coordinates }) {
    commit('setSuggestedChargingPoint', { coordinates })
    commit('setSuggestionModeState', { active: false })
  },
  resetSuggestedChargingPoint({ commit }) {
    commit('setSuggestedChargingPoint', { coordinates: null })
  },
  toggleSuggestionModeState({ commit, state }) {
    commit('setSuggestionModeState', { active: !state.isSuggestionModeActive })
    commit('setSuggestedChargingPoint', { coordinates: null })
    if (state.isSuggestionModeActive) {
      commit('setSelectedChargingPoint', { _id: null })
    }
  },
}
const mutations = {
  setChargingLocations(state, { locations }) {
    state.locations = [...state.locations, ...locations]
  },
  addChargingLocation(state, { location }) {
    const newLocation = Object.assign(location, { _id: location._id })
    state.locations = [...state.locations, newLocation]
  },
  setSelectedChargingPoint(state, { _id }) {
    state.selectedChargingPointRefId = _id
  },
  setSuggestedChargingPoint(state, { coordinates }) {
    if (!coordinates) {
      state.suggestedChargingpoint = null
      return
    }

    state.suggestedChargingpoint = {
      coordinates,
      properties: {
        status: 'suggestion',
      },
    }
  },
  setLoadedStatus(state, { status }) {
    state.loaded = status
  },
  setSuggestionModeState(state, { active }) {
    state.isSuggestionModeActive = !!active
  },
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
